/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import { filterSamples } from 'cio/utils/imports/import-attribute';
import { IdentifierKey } from 'cio/utils/identifiers';

@tagName('')
export default class Map extends Component {
  // external API
  import = null;

  validate = null;

  cancelImport() {
    throw new Error('You must pass a `cancelImport` action');
  }

  // internal state
  identificationOptions = Object.freeze([
    { label: 'By email address', value: 'email' },
    { label: 'By id', value: 'id' },
  ]);

  @action
  didInsertElement() {
    super.didInsertElement(...arguments);

    let identifier = this.import.validateRules.matchEmail ? IdentifierKey.Email : IdentifierKey.Id;
    let identifierColumn = this.import.preprocessMeta.attributes.find((attr) => attr.toLowerCase() === identifier);

    if (identifierColumn) {
      this.import.validateRules = {
        ...this.import.validateRules,
        useColumnIndex: this.import.preprocessMeta.attributes.indexOf(identifierColumn),
      };
    }
  }

  @computed('import.preprocessMeta.attributes', 'import.validateRules.noHeader')
  get attributeOptions() {
    let { import: record } = this;

    return record.preprocessMeta.attributes.map((attribute, index) => ({
      label: record.validateRules.noHeader ? `Column ${index + 1}` : attribute,
      value: index,
    }));
  }

  @computed('import.preprocessMeta.attributes', 'import.validateRules.useColumnIndex')
  get attribute() {
    let { import: record } = this;
    let {
      preprocessMeta: { attributes },
      validateRules: { useColumnIndex },
    } = record;

    if (isNone(useColumnIndex)) {
      return null;
    }

    return attributes[useColumnIndex];
  }

  @computed('import.preprocessMeta.{attributes,samples}', 'import.validateRules.{noHeader,useColumnIndex}')
  get samples() {
    let { import: record } = this;
    let {
      preprocessMeta,
      validateRules: { noHeader, useColumnIndex },
    } = record;

    let { attributes, samples } = preprocessMeta;

    return filterSamples(noHeader ? [attributes].concat(samples) : samples, useColumnIndex);
  }

  @action
  didChooseHeaderPresence(noHeader) {
    this.import.validateRules = { ...this.import.validateRules, noHeader };
  }

  @action
  didSelectAttribute({ value }) {
    this.import.validateRules = { ...this.import.validateRules, useColumnIndex: value };
  }
}
